<div class="banner">
    <span>{{ bannerText }}</span>
    <img src="assets/onboarding-banner-dotty.png"/>
</div>